export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      sidebar: { type: "horizontal-wrapper enterprice-type advance-layout" },
      sidebar_setting: "default-sidebar",
    },
    color: {
      layout_version: "light",
      color: "color-1",
      primary_color: "#ea4633",
      secondary_color: "#4b53a4",
      mix_background_layout: "light-only",
    },
    router_animation: null,
  };
}
export default ConfigDB;
